import React from 'react';

import SessionTemplate from 'templates/SessionTemplate';
import TitleLabel from 'components/TitleLabel';
import { Form } from './components';

export default function UserRegister() {
  return (
    <SessionTemplate>
      <TitleLabel title="Registrar" label="Registre na plataforma" />
      <Form />
    </SessionTemplate>
  );
}
